import { PrivacyGuardPlugin } from "@microsoft/1ds-privacy-guard-js";
import { LogTenantIdentifier } from "./constants/TelemetryConstants";
import { createEventIdentifier } from "./LoggingHelper";
import { PlannerPrivacyConcernMetadataProvider } from "./PlannerPrivacyConcernMetadataProvider";
import { EventType } from "./UTelLogHandler";
/**
 * PrivacyGuard class that implements the IPrivacyGuard interface.
 * It provides functionality to manage privacy concerns in the application.
 */ export class PrivacyGuard {
    getPlugin() {
        return this.privacyGuardPlugin;
    }
    getConfiguration() {
        const dataContexts = {
            UserName: this.userName,
            UserAlias: this.userAlias,
            IgnoredNameParts: [
                "Administrator",
                "Office",
                "User",
                "Group"
            ]
        };
        return {
            context: dataContexts,
            notificationEventName: this.notificationEventName,
            enabled: this.isPrivacyGuardEnabled,
            iKey: LogTenantIdentifier,
            privacyConcernMetadataProvider: this.privacyConcernMetadataProvider
        };
    }
    constructor(isPrivacyGuardEnabled, userName, userAlias){
        this.notificationEventName = createEventIdentifier(EventType.PrivacyConcern);
        this.userName = userName;
        this.userAlias = userAlias;
        this.isPrivacyGuardEnabled = isPrivacyGuardEnabled;
        this.privacyGuardPlugin = new PrivacyGuardPlugin();
        this.privacyConcernMetadataProvider = new PlannerPrivacyConcernMetadataProvider();
    }
}
